import { connect } from 'react-redux';
import { reduxForm, formValueSelector } from 'redux-form';
import GroupList from '../../components/Sales/groupList';
import {
  createGroup,
  deleteGroup,
  saveProductList,
  fetchCustomerGroupsDetail,
  fetchCustomerGroups, } from '../../actions/groupList_actions';
import {
  editCustomerGroup,
  fetchCustomers,
} from '../../actions/customers_actions';
import { setSaleRowValue, setValue } from '../../actions/sales_actions';
import { fetchInventories } from '../../actions/inventories_actions';

const groupList = reduxForm({
  form: 'favoriteList',
  destroyOnUnmount: false
})(GroupList);

const selector = formValueSelector('favoriteList');

function mapStateToProps(state) {
  const SearchType = selector(state, 'SearchType');
  const ProductInformation = selector(state, 'ProductInformation');
  const SelectedCustomer = selector (state, 'SelectedCustomer');

  return {
    SearchType,
    ProductInformation,
    SelectedCustomer,
    initialValues: { SearchType: 'RefNum' },

    groups: state.customerGroups.groups,
    groupsIsLoading: state.customerGroups.groupsIsLoading,
    groupsError: state.customerGroups.groupsError,
    isSaving: state.customerGroups.isLoading,
    saveError: state.customerGroups.error,
    userPermissions: state.auth.userPermissions,

    saveProductListSuccess: state.customerGroups.saveProductListSuccess,
    saveProductListError: state.customerGroups.saveProductListFailure,

    groupDetails: state.customerGroups.groupDetails,
    groupDetailsIsLoading: state.customerGroups.groupDetailsIsLoading,
    groupDetailsError: state.customerGroups.groupDetailsError,

    allCustomers: state.customers.all,
    allCustomersIsLoading: state.customers.isLoading,
    allCustomersError: state.customers.error,

  };
}

export default connect(mapStateToProps, {
  setSaleRowValue,
  setValue,
  fetchInventories,

  createGroup,
  deleteGroup,
  editCustomerGroup,
  saveProductList,
  fetchCustomerGroupsDetail,
  fetchCustomerGroups,
  fetchCustomers, })(groupList);



// WEBPACK FOOTER //
// ./master/jsx/containers/Sales/groupList.jsx